import { render, staticRenderFns } from "./ResponsiveRowLarge.vue?vue&type=template&id=994d50b2&scoped=true"
import script from "./ResponsiveRowLarge.vue?vue&type=script&lang=ts"
export * from "./ResponsiveRowLarge.vue?vue&type=script&lang=ts"
import style0 from "./ResponsiveRowLarge.vue?vue&type=style&index=0&id=994d50b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994d50b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('994d50b2')) {
      api.createRecord('994d50b2', component.options)
    } else {
      api.reload('994d50b2', component.options)
    }
    module.hot.accept("./ResponsiveRowLarge.vue?vue&type=template&id=994d50b2&scoped=true", function () {
      api.rerender('994d50b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/controltable/ResponsiveRowLarge.vue"
export default component.exports